/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import QS from 'qs';
// import { Toast } from 'vant';
import store from '../../store'
import { addressUrl } from "../url-public";
import { Message } from 'element-ui'
import router from '../../router/index'
export const address = addressUrl
// export const address = 'http://diagadmin.szfcar.com/diagadmin'

// 环境的切换
/*if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = '/api';
} else if (process.env.NODE_ENV == 'debug') {
  axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {*/
axios.defaults.baseURL = addressUrl;

// }

// 请求超时时间
axios.defaults.timeout = 200000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = store.state.token;
    token && (config.headers.Authorization = token);
    return config;
  },
  error => {
    return Promise.error(error);
  })
var isMessage = null
// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (response.data.msg == '未登录') {
        if (!isMessage) {
          isMessage = Message.error('登陆信息过期，请重新登陆')
          setTimeout(() => {
            isMessage = null
          }, 1500)
        }
        sessionStorage.removeItem('ms_token')
        router.push('/login')
      } else {
        return Promise.resolve(response)
      }
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 400:
          if (!isMessage) {
            isMessage = Message.error('登陆信息过期，请重新登陆')
            setTimeout(() => {
              isMessage = null
            }, 1500)
          }
          sessionStorage.removeItem('ms_token')
          router.push('/login')
          break
        case 401:
          if (!isMessage) {
            isMessage = Message.error('登陆信息过期，请重新登陆')
            setTimeout(() => {
              isMessage = null
            }, 1500)
          }
          sessionStorage.removeItem('ms_token')
          router.push('/login')
          break
        case 403:
          if (!isMessage) {
            isMessage = Message.error('登陆信息过期，请重新登陆')
            setTimeout(() => {
              isMessage = null
            }, 1500)
          }
          sessionStorage.removeItem('ms_token')
          router.push('/login')
          break
        case 404:
          isMessage = Message.error('资源路径404,请求不存在')

          setTimeout(() => {
            isMessage = null
          }, 1000)
          break
      }
      return Promise.reject(error.response);
    }
  }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8'
  // axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8'
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params,
        // responseType: 'blob',
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        console.log('err',err)
        reject(err.data)
      })
  });
}
export function get2(url, params) {
  axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8'
  // 请求超时时间
axios.defaults.timeout = 30000;
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params,
        // responseType: 'blob',
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        console.log('err',err)
        reject(err.data)
      })
  });
}
export function get1(url, params) {
  axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8'
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params,
        responseType: 'blob',
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
export function get3(url, params) {
  axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params,
        responseType: 'arraybuffer',
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  return new Promise((resolve, reject) => {
    axios.post(url, QS.stringify(params),{timeout:200000})
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}



/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function postJson(url, params) {
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  return new Promise((resolve, reject) => {
    axios.post(url, JSON.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err)
      })
  });
}


export function postForm(url, params) {
  axios.defaults.headers.post['Content-Type'] = 'form-data;charset=UTF-8'
  console.log(axios.defaults.headers.post['Content-Type'])
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err)
      })
  });
}


// WEBPACK FOOTER //
// ./src/assets/ajax/http.js